import routes from 'global/Constants/routes';
import { lazy } from 'react';

const CustomerPackagingConfirmation = lazy(() => import('../../pages/dashboard/admin/CustomerPackagingConfirmation'));

export const adminRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.customerPackagingConfirmation.path,
    component: CustomerPackagingConfirmation,
    isPrivate: routes.customerPackagingConfirmation.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
